import { AppEvent } from 'types/appEvent';
import { GiroPaymentManager } from 'types/giroPaymentManagerTypes';
import {
  createGiroPaymentManager,
  createGiroPaymentManagerData,
} from 'utils/giroPaymentManagerUtils';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextGiroPaymentManager = createReducer<
  GiroPaymentManager,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'GiroPaymentManager__Closed':
      return createGiroPaymentManager();
    case 'GiroPaymentManager__DataRecieved':
      const { data } = event;

      if (data) {
        return {
          ...prev,
          data,
          dataInvalidated: false,
        };
      }

      return prev;
    case 'GiroPaymentsPage__TableItemClicked':
      return {
        ...createGiroPaymentManager(),
        data: createGiroPaymentManagerData(),
        dataInvalidated: true,
        giroPaymentId: event.itemId,
      };
    case 'ClientDetails__ManageGiroPayment':
      return {
        ...createGiroPaymentManager(),
        data: createGiroPaymentManagerData(),
        dataInvalidated: true,
        giroPaymentId: event.paymentId,
      };
    case 'GiroPaymentsPage__ClientDetailsWillBeShown':
      return createGiroPaymentManager();
    case 'GiroPaymentsPage__PaymentCancelled':
    case 'GiroPaymentsPage__PaymentConfirmed':
      return {
        ...prev,
        data: prev.data,
        dataInvalidated: true,
      };
    case 'GiroPaymentManager__ScreenChanged':
      if (event.nextScreen === 'SUMMARY') {
        return {
          ...prev,
          screen: event.nextScreen,
          dataInvalidated: true,
        };
      }

      return {
        ...prev,
        screen: event.nextScreen,
      };
    default:
      return prev;
  }
});
